import { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { AlertMsg } from "./AlertMsg";

export const LoadScreen = ({ duration = 3000, onComplete }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        // Таймер на полную длительность анимации
        const animationTimer = setTimeout(() => {
            setFadeOut(true);
            
            // Таймер на завершение после fade-out
            const hideTimer = setTimeout(() => {
                setIsVisible(false);
                if (onComplete) onComplete();
            }, 500);

            return () => clearTimeout(hideTimer);
        }, duration);

        return () => clearTimeout(animationTimer);
    }, [duration, onComplete]);

    if (!isVisible) return null;

    return (
        <>
            <AlertMsg />
            <div 
                className="load-screen-container"
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "#000",
                    zIndex: 2000,
                    opacity: fadeOut ? 0 : 1,
                    transition: "opacity 0.5s ease-in-out",
                    pointerEvents: fadeOut ? "none" : "auto"
                }}
            >
                <div 
                    className="load-screen-gif"
                    style={{
                        background: "url('/LogoLC_gif.gif') center / contain no-repeat",
                        width: "100%",
                        height: "100%",
                        animation: fadeOut ? "none" : "none" // Можно добавить пульсацию
                    }}
                />
                
                {/* Опционально: индикатор прогресса */}
                <div className="load-screen-progress">
                    <div className="progress-bar">
                        <div 
                            className="progress-fill"
                            style={{
                                width: "100%",
                                animation: `progressFill ${duration}ms linear`
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

LoadScreen.propTypes = {
    duration: PropTypes.number,
    onComplete: PropTypes.func
};

// Добавьте в CSS:
// @keyframes progressFill {
//     from { width: 0%; }
//     to { width: 100%; }
// }